export default __webpack_public_path__ + "static/824-d8400dc3ac4012380f3e71ddf301e26d.gif";